module.exports = __webpack_public_path__ + "static/media/logo-alt.d9fbbb0d.png";